import React, { useContext } from 'react'
import { Flex } from 'pcln-design-system'
import styled from 'styled-components'
import { HighlightedFlex } from '@pcln/brand'
import PriceBreakersMediaCard from '@/components/Promos/Pricebreakers/PriceBreakersMediaCard'
import VIPPromoMediaCard from '@/components/Promos/VIP/VIPPromoMediaCard'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import IncredibleTileMediaCard from '@/components/Promos/IncredibleTile/IncredibleTileMediaCard'
import { useFeature } from '@pcln/feature-components'

const HighlightedFlexStyle = styled(HighlightedFlex)`
  gap: 16px;
`

export default function PromoFeatureBox() {
  const {
    isMobile = false,
    signInStatus: { signedIn = false }
  } = useContext(BootstrapDataContext)

  const heroSpacing = isMobile
    ? {
        my: [1, null, 4]
      }
    : {
        mt: [1, null, null, -4, 0],
        mb: [1, null, 4],
        style: { position: 'relative' }
      }

  const highlightColor = useFeature('siteExperience.highlightColor')

  return (
    <Flex mx="auto" justifyContent="center" {...heroSpacing}>
      <HighlightedFlexStyle
        shadowOffsetX={24}
        shadowOffsetY={24}
        maxWidth={1216}
        flexWrap={['wrap', null, 'unset']}
        shadowColor={highlightColor}
      >
        {isMobile ? (
          <>
            <IncredibleTileMediaCard contentFulFieldID="incredibleTile" />
            {signedIn ? <VIPPromoMediaCard /> : <PriceBreakersMediaCard />}
          </>
        ) : (
          <>
            {signedIn ? <VIPPromoMediaCard /> : <PriceBreakersMediaCard />}
            <IncredibleTileMediaCard contentFulFieldID="incredibleTile" />
          </>
        )}
      </HighlightedFlexStyle>
    </Flex>
  )
}
